var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.46 16.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89,1.92s0,.02,0,.03c0,.91-.65,1.73-1.55,1.91-.8,.16-1.64-.2-2.06-.9C-.15,2.25-.07,1.34,.45,.7,.96,.08,1.85-.16,2.61,.12c.76,.28,1.27,1,1.28,1.8Zm-1.28,4.28c-.76-.28-1.65-.04-2.16,.59-.52,.64-.6,1.55-.17,2.25,.43,.7,1.26,1.06,2.06,.9,.9-.18,1.54-1,1.55-1.91,0-.01,0-.02,0-.03-.02-.8-.53-1.52-1.28-1.8Zm0,6.09c-.76-.28-1.65-.04-2.16,.59-.52,.64-.6,1.55-.17,2.25,.43,.7,1.26,1.06,2.06,.9,.9-.18,1.54-1,1.55-1.91,0-.01,0-.02,0-.03-.02-.8-.53-1.52-1.28-1.8ZM8.91,3.85c.9-.18,1.54-1,1.55-1.91,0-.01,0-.02,0-.03-.02-.8-.53-1.52-1.28-1.8-.76-.28-1.65-.04-2.16,.59-.52,.64-.6,1.55-.17,2.25,.43,.7,1.26,1.06,2.06,.9Zm.26,2.35c-.76-.28-1.65-.04-2.16,.59-.52,.64-.6,1.55-.17,2.25,.43,.7,1.26,1.06,2.06,.9,.9-.18,1.54-1,1.55-1.91,0-.01,0-.02,0-.03-.02-.8-.53-1.52-1.28-1.8Zm0,6.09c-.76-.28-1.65-.04-2.16,.59-.52,.64-.6,1.55-.17,2.25,.43,.7,1.26,1.06,2.06,.9,.9-.18,1.54-1,1.55-1.91,0-.01,0-.02,0-.03-.02-.8-.53-1.52-1.28-1.8Z",
    fill: "#d9d7f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.d3ff10848659ec28fb83df117797c344.svg";
export { ForwardRef as ReactComponent };